'use client'

import 'react-notion-x/src/styles.css'
import { NotionRenderer } from 'react-notion-x'
import { type NotionAPI } from 'notion-client'
import Image from 'next/image'
import Link from 'next/link'
import { useMemo } from 'react'
import { env } from '@/env'

export default function ClientWrapper ({ data, imageBlockIds = [] }: {
  data: Awaited<ReturnType<NotionAPI['getPage']>>
  imageBlockIds?: string[]
}) {
  const imageBlockIdSet = useMemo(() => new Set(imageBlockIds), [imageBlockIds])

  return (
    <NotionRenderer
      recordMap={data}
      darkMode={false}
      components={{
        nextImage: Image,
        nextLink: Link,
      }}
      mapImageUrl={(url, block) => {
        if (block && imageBlockIdSet.has(block.id)) {
          return `https://${env.NEXT_PUBLIC_BUCKET_NAME}.s3.eu-central-1.amazonaws.com/data/notion/images/${block.id}`
        }
        return url
      }}
    />
  )
}
